/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Bag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Bag"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M4.055 15.145V8.28c0-1.027.75-1.871 1.711-1.973l.196-.01h11.92c1.037 0 1.883.86 1.907 1.938l.151 6.931q.006.221.057.436l.945 3.933c.282 1.174-.5 2.313-1.622 2.45l-.228.014v-1.983l-.945-3.933a4 4 0 0 1-.113-.871l-.151-6.932H5.962v6.864q-.001.488-.115.962l-.94 3.91V22c-1.163 0-2.035-1.066-1.892-2.23l.042-.234.94-3.91q.029-.12.043-.239zm15.037 4.872V22H4.908v-1.983zM12 2c2.282 0 4.131 1.923 4.132 4.297h-1.907c0-1.278-.996-2.313-2.226-2.313S9.775 5.018 9.775 6.297H7.868C7.868 3.923 9.717 2 11.999 2"
      className="SVG"
    />
  </svg>
);

export const BagIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'bag-icon'}
      icon={Bag}
      {...props}
      size={size}
    />
  );
};
